import * as React from 'react';
import { Search } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { TextInput } from '../../TextInput/src/TextInput.js';
import modules_1ba53a2f from '../styles/GlobalSearch.module.less.js';

const GlobalSearch = (props) => {
    const { globalFilter, isSearchFocused, setIsSearchFocused, handleGlobalSearch } = props;
    const cx = useStyles(modules_1ba53a2f);
    return (React.createElement(TextInput, { label: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435", icon: React.createElement(Search, { color: isSearchFocused ? 'var(--color-B100)' : '' }), className: cx('global-search'), value: globalFilter ?? '', onChange: handleGlobalSearch, onFocus: setIsSearchFocused.on, onBlur: setIsSearchFocused.off }));
};

export { GlobalSearch };
//# sourceMappingURL=GlobalSearch.js.map
